import { FeedTemplateIcon } from "./FeedTemplateIcon";

export default FeedTemplateIcon;
